import { HOST_URL } from 'config';
import Commons from '../../../../common/Js/Commons';
import AjaxUtil from '../../../../common/Js/AjaxHelper/AjaxUtil';

export default class GenericApi {
  static getSearchColumns(endpoint) {
    var url = HOST_URL + endpoint;
    return AjaxUtil.sendGet(url);
  }

  // url = /WebApp/Search/GetEntities
  static fetchDataInit(endpoint) {
    var url = HOST_URL + endpoint + '&start=0&length=25';
    return AjaxUtil.sendGet(url);
  }

  static fetchRiskDataInit(endpoint, rowsNumber) {
    var url = HOST_URL + endpoint + '&start=0&length=' + rowsNumber;
    return AjaxUtil.sendGet(url);
  }

  // url = "/WebApp/Search/GetEntities"
  static fetchSearched(endpoint, parameters, start, end, orderByDetails) {
    let _pathYadKefParam = Commons.CreateRegularYadKefSearchPattern(parameters, start, end, orderByDetails);
    var url = HOST_URL + endpoint + _pathYadKefParam;
    return AjaxUtil.sendGet(url);
  }

  // endpoint = "/WebApp/Search/SearchEntitiesAdvanced"
  static getSearchAdvancedColumns(
    endpoint,
    entityType,
    searchCriteria,
    searchHeadersCriteria,
    columns,
    start,
    end,
    orderByDetails,
    searchId
  ) {
    //Prepare url
    let _pathYadKefParam = Commons.CreateRegularYadKefSearchPattern(searchHeadersCriteria, start, end, orderByDetails);
    // post data
    let postDatax = Commons.CreateAdvancedYadKefSearchData(entityType, searchCriteria, columns, start, end, searchId);

    var url = HOST_URL + endpoint + _pathYadKefParam;
    return AjaxUtil.genericSendPost(url, JSON.stringify(postDatax));
  }

  static exportToExcel(endpoint, parameters, orderByDetails) {
    const pathYadKefParam = Commons.CreateRegularYadKefSearchPattern(parameters, orderByDetails);
    const url = `${HOST_URL}${endpoint}${pathYadKefParam}`;
    return AjaxUtil.postDownloadFile(url);
  }
}
